import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

import { useTimezone } from "../Providers/TimezoneProvider";
import AnalogClock from './AnalogClock';

type ClockMode = 'digital' | 'analog';

const MineClock: React.FC = () => {
  const { t } = useTranslation();
  const { timezone } = useTimezone();

  const [now, setNow] = useState(() => DateTime.now());
  useEffect(() => {
    const id = setInterval(() => setNow(DateTime.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const [clockMode, setClockMode] = useState<ClockMode>(() =>
    (localStorage.getItem('mineTimeClockMode') as ClockMode) ?? 'digital'
  );

  const toggleClockMode = () => {
    const next = clockMode === 'digital' ? 'analog' : 'digital';
    setClockMode(next);
    localStorage.setItem('mineTimeClockMode', next);
  };

  const mineNow = timezone ? now.setZone(timezone) : now;
  const label = clockMode === 'digital' ? t("clock.toFace") : t("clock.toDigital");

  return (
    <Tooltip title={label} arrow>
      <button
        type="button"
        onClick={toggleClockMode}
        className="hidden sm:flex items-center gap-2 opacity-75 hover:opacity-100 transition cursor-pointer select-none"
        aria-label={label}
      >
        {!timezone ? (
          clockMode === 'digital' ? (
            <span className="font-mono tabular-nums animate-pulse select-none">{"‒‒:‒‒:‒‒"}</span>
          ) : (
            <div className="w-8 h-8 rounded-full animate-pulse bg-current opacity-30" />
          )
        ) : clockMode === 'digital' ? (
          <span className="font-mono tabular-nums">{mineNow.toFormat('HH:mm:ss')}</span>
        ) : (
          <AnalogClock hours={mineNow.hour} minutes={mineNow.minute} seconds={mineNow.second} />
        )}
      </button>
    </Tooltip>
  );
};

export default MineClock;
